import { render, staticRenderFns } from "./AnimatedNumberComponent.vue?vue&type=template&id=4683cd62&"
import script from "./AnimatedNumberComponent.vue?vue&type=script&lang=js&"
export * from "./AnimatedNumberComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports